// Indian rupee formatting
export function formatINR(v, withSymbol = true) {
  if (v === null || v === undefined || v === "") return withSymbol ? "₹0.00" : "0.00";
  const n = typeof v === "string" ? parseFloat(v) : v;
  if (isNaN(n)) return withSymbol ? "₹0.00" : "0.00";
  const abs = Math.abs(n);
  const [whole, frac = "00"] = abs.toFixed(2).split(".");
  let formattedWhole = whole;
  if (whole.length > 3) {
    const last3 = whole.slice(-3);
    const rest = whole.slice(0, -3);
    const parts = [];
    let r = rest;
    while (r.length > 2) {
      parts.unshift(r.slice(-2));
      r = r.slice(0, -2);
    }
    if (r) parts.unshift(r);
    formattedWhole = parts.join(",") + "," + last3;
  }
  const sign = n < 0 ? "-" : "";
  return (withSymbol ? "₹" : "") + sign + formattedWhole + "." + frac;
}

export function formatDate(d) {
  if (!d) return "-";
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatMonth(m) {
  if (!m) return "-";
  const [y, mo] = m.split("-");
  const dt = new Date(parseInt(y), parseInt(mo) - 1, 1);
  return dt.toLocaleDateString("en-IN", { month: "short", year: "numeric" });
}
